import { motion, AnimatePresence } from 'framer-motion'
import { Trophy, Sparkles } from 'lucide-react'

const ResultDisplay = ({ result, onClose }) => {
  if (!result) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0, y: 50 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0, y: 50 }}
        transition={{ 
          type: "spring", 
          stiffness: 300, 
          damping: 20,
          delay: 0.5 
        }}
        className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ 
            type: "spring", 
            stiffness: 400, 
            damping: 25,
            delay: 0.7 
          }}
          className="bg-white rounded-3xl p-8 mx-4 max-w-md w-full text-center shadow-2xl border-2 border-theme-200"
          onClick={(e) => e.stopPropagation()}
        >
          {/* 装饰性星星 */}
          <div className="relative">
            <motion.div
              animate={{ 
                rotate: 360,
                scale: [1, 1.2, 1]
              }}
              transition={{ 
                duration: 2, 
                repeat: Infinity,
                ease: "linear"
              }}
              className="absolute -top-4 -left-4"
            >
              <Sparkles className="w-8 h-8 text-theme-400" />
            </motion.div>
            
            <motion.div
              animate={{ 
                rotate: -360,
                scale: [1, 1.1, 1]
              }}
              transition={{ 
                duration: 3, 
                repeat: Infinity,
                ease: "linear"
              }}
              className="absolute -top-4 -right-4"
            >
              <Sparkles className="w-6 h-6 text-theme-400" />
            </motion.div>
          </div>

          {/* 奖杯图标 */}
          <motion.div
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ 
              type: "spring", 
              stiffness: 500, 
              damping: 15,
              delay: 1 
            }}
            className="mb-6"
          >
            <Trophy className="w-16 h-16 text-theme-500 mx-auto" />
          </motion.div>

          {/* 结果文字 */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2 }}
            className="text-3xl font-bold text-slate-900 mb-4"
          >
            恭喜！
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.4 }}
            className="mb-6"
          >
            <div
              className="inline-block px-6 py-3 rounded-2xl text-2xl font-bold text-white shadow-lg"
              style={{ backgroundColor: result.color }}
            >
              {result.text}
            </div>
          </motion.div>

          {/* 关闭按钮 */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClose}
            className="px-8 py-3 bg-theme-500 text-white font-bold rounded-xl hover:bg-theme-600 transition-all duration-300 shadow-lg"
          >
            好欸
          </motion.button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}

export default ResultDisplay
